<template>
  <div class="body-container" id="app">
    <component :is="style">
      .el-loading-spinner .path{ stroke:
      {{ myTheme.topMenu.normal.backgroundColor }} } .bg-primary{
      background-color:{{ myTheme.topMenu.normal.backgroundColor }}; color:{{
        myTheme.topMenu.normal.color
      }}; } .form-control:focus, .el-date-picker .el-input
      .el-input__inner:focus, .form-group .el-input__inner:focus{
      border-color:{{ myTheme.customizeButton.backgroundColor }}; } .form-group
      .el-select .el-input__inne:focus, .el-select .el-input.is-focus
      .el-input__inner,{ border:1px solid
      {{ myTheme.customizeButton.backgroundColor }}; }
      .el-picker-panel.el-date-picker.date-picker-primary { background:{{
        myTheme.customizeButton.backgroundColor
      }}; color :{{ myTheme.customizeButton.color }} !important; }
      .el-picker-panel.el-date-picker.date-picker-primary.el-popper[x-placement^=bottom]
      .popper__arrow:after{ border-bottom-color:
      {{ myTheme.customizeButton.backgroundColor }}; } .date-picker-primary
      .el-picker-panel__content .el-date-table td.current span{ color:{{
        myTheme.customizeButton.backgroundColor
      }}; font-weight: bold } .url-color{ color :
      {{ myTheme.primaryTextColor }} !important } .url-color:hover,
      .url-color:focus{ color : {{ myTheme.secondaryTextColor }} !important }
      .el-select-dropdown__item.selected{ color :{{ myTheme.primaryTextColor }}
      !important; } .el-button:active { color:
      {{ myTheme.customizeButton.color }}; border-color:
      {{ myTheme.customizeButton.color }}; outline: none; } .el-button:focus,
      .el-button:hover { color: {{ myTheme.customizeButton.color }};
      border-color: {{ myTheme.customizeButton.color }}; background-color:
      {{ myTheme.customizeButton.backgroundColor }}; } .review-item blockquote {
      border-left-color: {{ myTheme.customizeButton.backgroundColor }}; } @media
      screen and (max-width: 991px) { .mobile-bg-primary{ background-color:{{
        myTheme.topMenu.normal.backgroundColor
      }}; color:{{ myTheme.topMenu.normal.color }}; } } .modal-content,
      .dg-main-content{ border:3px solid
      {{ myTheme.topMenu.normal.backgroundColor }}; border-radius : 0.5rem }
      .el-picker-panel.el-date-picker .el-popper[x-placement^=bottom]
      .popper__arrow::after { border-bottom-color:
      {{ myTheme.customizeButton.backgroundColor }}; }
      .el-picker-panel.el-date-picker .el-popper[x-placement^=top]
      .popper__arrow::after { border-top-color:
      {{ myTheme.customizeButton.backgroundColor }}; } .fab-button{ background:
      {{ myTheme.servicesButton.active.backgroundColor }}; border: 0; }
      .tracking-order-cls{ fill:{{ myTheme.servicesButton.active.color }}; }
      .el-message-box{ border: 3px solid {{ myTheme.topMenu.normal.backgroundColor }}}
      .smartbanner-android {
      box-shadow: inset 0 4px 0 {{ myTheme.topMenu.normal.backgroundColor }}; }
      .smartbanner-android .smartbanner-button { color:
      {{ myTheme.servicesButton.active.color }} } .smartbanner-android
      .smartbanner-button-text { background:
      {{ myTheme.servicesButton.active.backgroundColor }}
      } 
      .el-button--primary, .el-button--primary:hover{ 
        background:{{ myTheme.customizeButton.backgroundColor }}; 
        color: {{ myTheme.customizeButton.color }};
        border-color:{{ myTheme.customizeButton.backgroundColor }}
      }
      .form-check .form-check-sign::after{
        color:{{ myTheme.customizeButton.backgroundColor }}
      }
    </component>
    <!--vue-progress-bar></!--vue-progress-bar-->
    <!-- v-if="!isHome || !IsWebView" -->
    <router-view name="header" id="header" transparent="true" />
    <div class="wrapper">
      <router-view />
      <!--router-view name="dialog"></router-view-->
    </div>
    <router-view
      name="footer"
      id="footer"
      v-if="!isHome || !helpers.IsWebView()"
    />
    <notifications
      group="bottomRight"
      position="bottom right"
      animation-type="velocity"
    />
    <notifications
      group="topRight"
      width="300px"
      position="top right"
      animation-type="velocity"
    />
    <notifications
      group="topCenter"
      width="300px"
      position="top center"
      animation-type="velocity"
    />
    <div @click="redirectToTracking" v-if="showTrackingButton">
      <fab fab-icon="k-icon-order-tracker"></fab>
    </div>
    <download-app-modal
      ref="downloadAppModal"
      :business="business"
      v-if="business"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { cartManager, helpers, subdomain } from "@/utilities";
import { Fab } from "@/components";
import DownloadAppModal from "@/views/components/DownloadAppModal";
import orderTackerMixin from "@/mixins/orderTrackerMixin";
import { isAndroid } from "mobile-device-detect";
export default {
  metaInfo() {
    return {
      title: `${
        this.business
          ? `${this.business.name} | What The Fork`
          : "What The Fork"
      }`,
      meta: [
        { charset: "utf-8" },
        {
          name: "description",
          content: this.business
            ? this.business.description
            : "What The Fork are the only online ordering system for restaurants and takeaways with table ordering that provide a capped cost feature.",
        },
        {
          name: "viewport",
          content:
            "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=1, shrink-to-fit=no",
        },
        { property: "og:locale", content: "en_GB" },
        { property: "og:type", content: "website" },
        {
          property: "og:title",
          content: `${
            this.business
              ? `${this.business.name} | What The Fork`
              : "What The Fork"
          }`,
        },
        {
          property: "og:description",
          content: this.business
            ? this.business.description
            : "What The Fork are the only online ordering system for restaurants and takeaways with table ordering that provide a capped cost feature.",
        },
        {
          property: "og:url",
          content: `https://${subdomain.get()}.whatthefork.app`,
        },
        {
          property: "og:site_name",
          content: `${this.business ? this.business.name : "What The Fork"} `,
        },
        {
          property: "twitter:title",
          content: `${
            this.business
              ? `${this.business.name} | What The Fork`
              : "What The Fork"
          }`,
        },
        {
          property: "twitter:description",
          content: this.business
            ? this.business.description
            : "What The Fork are the only online ordering system for restaurants and takeaways with table ordering that provide a capped cost feature.",
        },
        {
          property: "twitter:site",
          content: `https://${subdomain.get()}.whatthefork.app`,
        },
        { property: "twitter:creator", content: "@WhatTheForkApp" },
      ],
    };
  },
  mixins: [orderTackerMixin],
  components: {
    Fab,
    DownloadAppModal,
  },
  computed: {
    ...mapGetters(["isAuthenticated", "guestData"]),
    ...mapState({
      user: (state) => state.auth.user,
      business: (state) => state.business,
    }),
    isHome() {
      return this.$route.name === "home";
    },
    showTrackingButton() {
      return (
        this.$route.name === "home" && this.user && this.getTrackedOrder.length
      );
    },
  },
  data() {
    return {
      style: "style",
      position: "bottom-right",
      fabActions: [
        {
          name: "cache",
          icon: "cached",
        },
        {
          name: "alertMe",
          icon: "add_alert",
        },
      ],
      helpers,
    };
  },
  methods: {
    ...mapActions(["logoutRequest", "saveTrackedOrder"]),
    logout() {
      this.logoutRequest();
    },
    redirectToTracking() {
      this.$router.push({
        name: "tracking-order",
        params: { id: this.getTrackedOrder[0].id },
      });
    },
    showFourWaysDownloadModal() {
      if (subdomain.get() != "fourwayskirkliston") return; //show this modal onnly for fourwayskirkliston
      if (helpers.IsWebView() && isAndroid && this.getChannel != 6) {
        // 6 is User-App Android
        this.$refs.downloadAppModal.openModal();
      }
    },
  },
  mounted() {
    cartManager.InitCart();
    this.showFourWaysDownloadModal();
  },
};
</script>
